export enum HoldingExclude {
  TotalInvested = 1,
  CostBasis = 2,
  ReturnofCapital = 3,
  Proceeds = 4,
  Valuation = 5,
  ValuationDate = 6,
  TVPI = 7,
  RVPI = 8,
  DPI = 9,
  Allow = 10,
}

export enum ErrorCodes {
  Success = 200,
  UnAuthorized = 401,
  NotFound = 404,
  InternalServerError = 500,
  Generic = 600,
  Errorinattributename = 0,
}

export enum DataAreaType {
  Investments = "-327",
  Investors = "-326",
  "Fund of Funds" = "-328",
}

export enum FunctionGroup {
  BenchmarkRank = "BenchmarkRank",
  Cfar = "Cfar",
  Getattributes = "Getattributes",
  Holdings = "Holdings",
  PeerGroupCapitalization = "PeerGroupCapitalization",
  PercentileRank = "PercentileRank",
  PercentRankMeasures = "PercentRankMeasures",
  Pooledbenchmark = "Pooledbenchmark",
  Pooledbenchmarkphase2 = "Pooledbenchmarkphase2",
  Profiler = "Profiler",
  TargetSize = "TargetSize",
  UAMeasures = "UAMeasures",
  Minandmaxdate = "Minandmaxdate",
  Measures = "Measures",
  BenchmarkRankUniverse = "BenchmarkRankUniverse",
  Pooledbenchmarkphase2Univ = "Pooledbenchmarkphase2Univ",
  PooledbenchmarkUniv = "PooledbenchmarkUniv",
}

export enum MeasuresType {
  Unfunded = "UNFUNDED",
  Valuation = "VALUATION",
  Dist = "DIST",
  BaseCommitment = "BASECOMMITMENT",
  Stock = "Stock",
  Twrr = "TWRR",
  CostBasis = "CostBasis",
  Funding = "Funding",
  Paidin = "PAIDIN",
  PooledFundSize = "POOLEDFUNDSIZE",
  DistRecallableCapital = "DISTRECALLABLECAPITAL",
  DistOther = "DISTOTHER",
  DistReturnOfCapital = "DistReturnOfCapital",
  DistCapitalGains = "DISTCAPITALGAINS",
  DistIncome = "DISTINCOME",
  CashRecallableCapital = "CashRecallableCapital",
  CashIncome = "CashIncome",
  CashOther = "CashOther",
  CashReturnOfCapital = "CashReturnOfCapital",
  CashCapitalGains = "CashCapitalGains",
  Adjustedcommitment = "ADJUSTEDCOMMITMENT",
  NetCapitalContributed = "NetCapitalContributed",
  IRRICMMultiIndex = "IRRICMMultiIndex",
  IRRSpreadMultiIndex = "IRRSpreadMultiIndex",
  ICMValuationMultiIndex = "ICMValuationMultiIndex",
  KSPMEMultiIndex = "KSPMEMultiIndex",
  DirectAlphaMultiIndex = "DirectAlphaMultiIndex",
  MIRRMultiIndex = "MIRRMultiIndex",
  IRR = "IRR",
  Cash = "Cash",
  Fees = "Fees",
  TWRR = "TWRR",
  IRRPercentile = "IRR.Percentile",
  KS_PME_Percentile = "KS_PME.Percentile",
  LN_ICMIRR_Percentile = "LN_ICMIRR.Percentile",
  LN_ICMIRRSpread_Percentile = "LN_ICMIRRSpread.Percentile",
  LN_ICMValuationSpread_Percentile = "LN_ICMValuationSpread.Percentile",
  GSS_DirectAlpha_Percentile = "GSS_DirectAlpha.Percentile",
  IRR_QTDPercentile = "IRR_QTD.Percentile",
  IRR_YTDPercentile = "IRR_YTD.Percentile",
  IRR_1YearPercentile = "IRR_1Year.Percentile",
  IRR_3YearPercentile = "IRR_3Year.Percentile",
  IRR_5YearPercentile = "IRR_5Year.Percentile",
  IRR_10YearPercentile = "IRR_10Year.Percentile",
  IRR_15YearPercentile = "IRR_15Year.Percentile",
  IRR_20YearPercentile = "IRR_20Year.Percentile",
  DPIPercentile = "DPI.Percentile",
  TotalInvested = "TotalInvested",
  ReturnOfCapital = "ReturnOfCapital",
  Proceeds = "Proceeds",
  DPI = "DPI",
  RVPI = "RVPI",
  TVPI = "TVPI",
  NetCashFlowPercentile = "NetCashFlow.Percentile",
  IRRProfiler = "IRR.Profiler",
  MIRRProfiler = "MIRR.Profiler",
  RIRRProfiler = "RIRR.Profiler",
  DPIProfiler = "DPI.Profiler",
  RVPIProfiler = "RVPI.Profiler",
  TVPIProfiler = "TVPI.Profiler",
  DistributionsProfiler = "Distributions.Profiler",
  Distributions_AnnualProfiler = "Distributions_Annual.Profiler",
  NetCashFlowProfiler = "NetCashFlow.Profiler",
  NetCashFlow_AnnualProfiler = "NetCashFlow_Annual.Profiler",
  PaidInCapitalProfiler = "PaidInCapital.Profiler",
  PaidInCapital_AnnualProfiler = "PaidInCapital_Annual.Profiler",
  ValuationProfiler = "Valuation.Profiler",
  GSS_DirectAlphaProfiler = "GSS_DirectAlpha.Profiler",
  KS_PMEProfiler = "KS_PME.Profiler",
  LN_ICMIRRProfiler = "LN_ICMIRR.Profiler",
  LN_ICMIRRSpreadProfiler = "LN_ICMIRRSpread.Profiler",
  LN_ICMValuationSpreadProfiler = "LN_ICMValuationSpread.Profiler",
  MIRRPooled = "MIRR.Pooled",
  GSS_DirectAlphaPooled = "GSS_DirectAlpha.Pooled",
  KS_PMEPooled = "KS_PME.Pooled",
  LN_ICMIRRPooled = "LN_ICMIRR.Pooled",
  LN_ICMIRRSpreadPooled = "LN_ICMIRRSpread.Pooled",
  LN_ICMValuationSpreadPooled = "LN_ICMValuationSpread.Pooled",
  CapitalizationPooled = "Capitalization.Pooled",
  PaidInCapitalPooled = "PaidInCapital.Pooled",
  NetCashFlowPooled = "NetCashFlow.Pooled",
  DistributionsPooled = "Distributions.Pooled",
  RIRRPooled = "RIRR.Pooled",
  IRR_NWPooled = "IRR_NW.Pooled",
  TVPIPooled = "TVPI.Pooled",
  ValuationPooled = "Valuation.Pooled",
  RVPIPooled = "RVPI.Pooled",
  DPIPooled = "DPI.Pooled",
  IRR_20YearPooled = "IRR_20Year.Pooled",
  IRR_15YearPooled = "IRR_15Year.Pooled",
  IRR_10YearPooled = "IRR_10Year.Pooled",
  IRR_5YearPooled = "IRR_5Year.Pooled",
  IRR_3YearPooled = "IRR_3Year.Pooled",
  IRR_1YearPooled = "IRR_1Year.Pooled",
  IRR_YTDPooled = "IRR_YTD.Pooled",
  IRR_QTDPooled = "IRR_QTD.Pooled",
  IRRPooled = "IRR.Pooled",
  TWRR_QTDPooled = "TWRR_QTD.Pooled",
  IRRPercentRank = "IRR.PercentRank",
  IRR_QTDPercentRank = "IRR_QTD.PercentRank",
  IRR_YTDPercentRank = "IRR_YTD.PercentRank",
  IRR_1YearPercentRank = "IRR_1Year.PercentRank",
  IRR_3YearPercentRank = "IRR_3Year.PercentRank",
  IRR_5YearPercentRank = "IRR_5Year.PercentRank",
  IRR_10YearPercentRank = "IRR_10Year.PercentRank",
  IRR_15YearPercentRank = "IRR_15Year.PercentRank",
  IRR_20YearPercentRank = "IRR_20Year.PercentRank",
  DPIPercentRank = "DPI.PercentRank",
  RVPIPercentRank = "RVPI.PercentRank",
  TVPIPercentRank = "TVPI.PercentRank",
  ValuationMinDate = "Valuation.MinDate",
  ValuationMaxDate = "Valuation.MaxDate",
  FeesMinDate = "Fees.MinDate",
  FeesMaxDate = "Fees.MaxDate",
  CashMinDate = "Cash.MinDate",
  CashMaxDate = "Cash.MaxDate",
  FundingMinDate = "Funding.MinDate",
  FundingMaxDate = "Funding.MaxDate",
  TargetSize = "TargetSize",
  VALUATION_PERCENTRANK = "Valuation.PercentRank",
  RIRR_PERCENTRANK = "RIRR.PercentRank",
  DISTRIBUTIONS_PERCENTRANK = "Distributions.PercentRank",
  NETCASHFLOW_PERCENTRANK = "NetCashFlow.PercentRank",
  PAIDINCAPITAL_PERCENTRANK = "PaidInCapital.PercentRank",
  MIRR_PERCENTRANK = "MIRR.PercentRank",
  GSS_DIRECTALPHA_PERCENTRANK = "GSS_DirectAlpha.PercentRank",
  KS_PME_PERCENTRANK = "KS_PME.PercentRank",
  LN_ICMIRR_PERCENTRANK = "LN_ICMIRR.PercentRank",
  LN_ICMIRRSPREAD_PERCENTRANK = "LN_ICMIRRSpread.PercentRank",
  LN_ICMVALUATIONSPREAD_PERCENTRANK = "LN_ICMValuationSpread.PercentRank",
  DISTRIBUTIONS_PERCENTILE = "Distributions.Percentile",
  MIRR_PERCENTILE = "MIRR.Percentile",
  PAIDINCAPITAL_PERCENTILE = "PaidInCapital.Percentile",
  RIRR_PERCENTILE = "RIRR.Percentile",
  RVPI_PERCENTILE = "RVPI.Percentile",
  TVPI_PERCENTILE = "TVPI.Percentile",
  VALUATION_PERCENTILE = "Valuation.Percentile",
  StockMaxDate="Stock.MaxDate",
  StockMinDate="Stock.MinDate",
  CostBasisFXGainLoss="CostBasisFXGainLoss",
  StockCost="StockCost",
  StockCapitalGains="StockCapitalGains",
  StockRecallableCapital="StockRecallableCapital",
  StockReturnOfCapital="StockReturnOfCapital",
  RIRR = "RIRR",
 
}
